import {
	fetchLocationsWithRegions,
	fetchLocationsWithBuyerCompaniesForSupplier,
	locationsRestCrudThunks,
} from '../thunks/locations_thunks';
import { isBuyerOrInternalTech, isInternalTech } from '../utils/AuthUtils';
import { spendCategoriesRestCrudThunks } from '../thunks/spend_categories_thunks';
import { workOrderPrioritiesRestCrudThunks } from '../thunks/work_order_priorities_thunks';
import { assetTypesRestCrudThunks } from '../thunks/asset_types_thunks';
import { assetsRestCrudThunks } from '../thunks/assets_thunks';
import { resolutionTypesRestCrudThunks } from '../thunks/resolution_types_thunks';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../actions/work_orders_actions';
import {
	fetchSupplierFacilitiesInPrivateNetwork,
	supplierFacilitiesRestCrudThunks,
	supplierFacilitiesRestCrudThunksForBuyer,
} from '../thunks/supplier_facilities_thunks';
import {
	problemTypesHeirarchical,
	problemTypesRestCrudThunks,
} from '../thunks/problem_types_thunks';
import {
	areasRestCrudThunks,
	fetchAreasWithHeirarchy,
	fetchDistinctAreasHeirarchy,
} from '../thunks/areas_thunks';
import { ROLE_TYPES } from '../utils/DataConstants';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { workOrderLabelsRestCrudThunks } from '../thunks/work_order_labels_thunks';
import {
	getContactsWithInternalTechs,
	getContactsForThirdPartySuppliers,
} from '../thunks/contacts_thunks';
import { bindThunk } from '../utils/DataFormatterUtils';
import { plannedMaintenanceSchedulesRestCrudThunks } from '../thunks/planned_maintenance_schedules_thunks';
import {
	meterTypesRestCrudThunksForBuyer,
	meterTypesRestCrudThunksForSupplier,
} from '../thunks/meter_types_thunks';
import { brandsRestCrudThunks } from '../thunks/brands_thunks';
import {
	depreciationClassesRestCrudThunksForBuyer,
	depreciationClassesRestCrudThunksForSupplier,
} from '../thunks/depreciation_class_thunks';
import {
	regionsRestCrudThunksForBuyer,
	regionsRestCrudThunksForSupplier,
	fetchRegionsWithChildrenForBuyer,
	fetchRegionsWithChildrenForSupplier,
} from '../thunks/regions_thunks';
import {
	locationTypesRestCrudThunksForBuyer,
	locationTypesRestCrudThunksForSupplier,
} from '../thunks/location_types_thunks';
import {
	plannedMaintenanceTemplatesRestCrudThunksForBuyer,
	plannedMaintenanceTemplatesRestCrudThunksForSupplier,
} from '../thunks/planned_maintenance_templates_thunks';
import { getFilters } from '../utils/FilterUtils';
import {
	vendorsRestCrudThunksForBuyer,
	vendorsRestCrudThunksForSupplier,
} from '../thunks/vendors_thunks';
import { labelsOnPartsRestCrudThunksForSupplier } from '../thunks/labels_thunks';
import { labelsOnAssetsRestCrudThunks } from '../thunks/asset_labels_thunks';
import { ContractorPrivateNetworksRestCrudThunksForSupplier } from '../thunks/contractors_private_networks_thunks';
import {
	contractorClientsRestCrudThunksForBuyer,
	contractorClientsRestCrudThunksForSupplier,
} from '../thunks/contractor_clients_thunks';
import {
	contractorLocationsRestCrudThunksForBuyer,
	contractorLocationsRestCrudThunksForSupplier,
} from '../thunks/contractor_locations_thunks';
import { fieldTechsRestCrudThunksForSupplier } from '../thunks/field_techs_thunks';
import {
	assetTypesAdditionalFieldsRestCrudThunksForBuyer,
	assetTypesAdditionalFieldsRestCrudThunksForSupplier,
} from '../thunks/asset_types_additional_fields_thunks';
import {
	customersRestCrudThunksForBuyer,
	customersRestCrudThunksForSupplier,
} from '../thunks/customers_thunks';
import {
	siteSurveysGroupedRestCrudThunksForBuyer,
	siteSurveysGroupedRestCrudThunksForSupplier,
} from '../thunks/site_surveys_grouped_thunks';

export const useFilters = ({
	filterTargetCollectionName = 'workOrdersAdvancedFilters',
	overviewCollectionName = 'workOrdersIndex',
	updateFilters,
} = {}) => {
	const dispatch = useDispatch();

	const userType = useSelector((state) => state.session.userType);
	const currentUser = useSelector((state) => state.session.currentUser);
	// === equivalent of mapStateToProps ===
	const companyConfig = useSelector((state) => state.company_config.detail);
	const locations = useSelector((state) => state.locations);
	const areas = useSelector((state) => state.areas);
	const workOrderPriorities = useSelector((state) => state.work_order_priorities);
	const assetTypes = useSelector((state) => state.asset_types);
	const problemTypes = useSelector((state) => state.problem_types);
	const supplierFacilities = useSelector((state) => state.supplier_facilities);
	const assets = useSelector((state) => state.assets);
	const spendCategories = useSelector((state) => state.spend_categories);
	const resolutionTypes = useSelector((state) => state.resolution_types);
	const users = useSelector((state) => state.all_contacts);
	const planned_maintenance_schedules = useSelector((state) => state.planned_maintenance_schedules);
	const brands = useSelector((state) => state.brands);
	const depreciationClasses = useSelector((state: any) => state.depreciation_classes);
	const regions = useSelector((state: any) => state.regions);
	const locationTypes = useSelector((state: any) => state.location_types);
	const plannedMaintenanceTemplates = useSelector(
		(state: any) => state.planned_maintenance_templates
	);
	const meterTypes = useSelector((state: any) => state.meter_types);
	const vendors = useSelector((state: any) => state.vendors);
	const labels = useSelector((state: any) => state.labels);
	const assetLabels = useSelector((state: any) => state.asset_labels);
	const contractorClients = useSelector((state: any) => state.contractor_clients);
	const contractorLocations = useSelector((state: any) => state.contractor_locations);
	const contractorPrivateNetworks = useSelector((state: any) => state.contractor_private_networks);
	const fieldTechs = useSelector((state: any) => state.field_techs);
	const assetTypesAdditionalFields = useSelector(
		(state: any) => state.asset_types_additional_fields
	);
	const customers = useSelector((state: any) => state.customers);
	const siteSurveysGrouped = useSelector((state: any) => state['site_surveys/grouped']);
	// Full slice (not a flattened list) so the "Labels" advanced filter can paginate +
	// infinite-scroll like the other async filters (Priority, Asset Type, etc.).
	const workOrderLabels = useSelector((state: any) => state.work_order_labels);

	// === equivalent of mapDispatchToProps ===
	const boundActions = useMemo(
		() => ({
			fetchSpendCategories: bindThunk(dispatch, spendCategoriesRestCrudThunks(userType).read),
			fetchMultipleSpendCategories: bindThunk(
				dispatch,
				spendCategoriesRestCrudThunks(userType).readMultiple
			),
			fetchWorkOrderPriorities: bindThunk(
				dispatch,
				workOrderPrioritiesRestCrudThunks(userType).read
			),
			fetchMultipleWorkOrderPriorities: bindThunk(
				dispatch,
				workOrderPrioritiesRestCrudThunks(userType).readMultiple
			),
			// AdvancedFilters calls every filter's fetch with { name: searchText }, but the
			// work_order_labels endpoint filters on `search` (WorkOrderLabelDao does
			// `label LIKE %search%`); `name` isn't a recognized key, so it returns the full
			// catalogue. Translate name -> search here. The catalogue renders unpaginated.
			fetchWorkOrderLabels: ({ name, ...params } = {}, ...rest) =>
				dispatch(
					workOrderLabelsRestCrudThunks(userType).read(
						{ ...params, ...(name ? { search: name } : {}), no_pagination: true },
						...rest
					)
				),
			fetchMultipleWorkOrderLabels: (ids, targetCollectionName) =>
				dispatch(
					workOrderLabelsRestCrudThunks(userType).read(
						{ no_pagination: true },
						'workOrderLabelsIndex'
					)
				),
			fetchAssetTypes: bindThunk(dispatch, assetTypesRestCrudThunks(userType).readLite),
			fetchMultipleAssetTypes: bindThunk(dispatch, assetTypesRestCrudThunks(userType).readMultiple),
			fetchAssets: bindThunk(dispatch, assetsRestCrudThunks(userType).readLite),
			fetchMultipleAssets: bindThunk(dispatch, assetsRestCrudThunks(userType).readMultiple),
			fetchMultipleResolutionTypes: bindThunk(
				dispatch,
				resolutionTypesRestCrudThunks(userType).readMultiple
			),
			fetchResolutionTypes: bindThunk(dispatch, resolutionTypesRestCrudThunks(userType).read),
			fetchMultipleLocations: bindThunk(dispatch, locationsRestCrudThunks(userType).readMultiple),
			fetchLocationsWithHierarchy: (
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			) => {
				const fetchFn =
					userType === ROLE_TYPES.SUPPLIER && !isInternalTech(currentUser)
						? fetchLocationsWithBuyerCompaniesForSupplier
						: fetchLocationsWithRegions(userType);
				return dispatch(
					fetchFn(
						{ ...params, noIsActiveFilter: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
					)
				);
			},

			clearAllFilters: bindThunk(dispatch, WORK_ORDERS_CRUD_ACTION_CREATORS.clearAllFilters),

			fetchSupplierFacility: bindThunk(dispatch, supplierFacilitiesRestCrudThunksForBuyer.readOne),
			fetchMultipleSupplierFacilitiesInPrivateNetwork: bindThunk(
				dispatch,
				supplierFacilitiesRestCrudThunks(userType).readMultiple
			),

			fetchProblemTypes: bindThunk(dispatch, problemTypesHeirarchical(userType)),
			fetchMultipleProblemTypes: bindThunk(
				dispatch,
				problemTypesRestCrudThunks(userType).readMultiple
			),
			fetchSupplierFacilitiesInPrivateNetwork: bindThunk(
				dispatch,
				fetchSupplierFacilitiesInPrivateNetwork(userType)
			),
			fetchAreasDistinct: bindThunk(dispatch, fetchDistinctAreasHeirarchy(userType)),
			fetchAreaCount: (params = {}) =>
				dispatch(areasRestCrudThunks(userType).countBy(params, 'all')),
			fetchUsers: bindThunk(
				dispatch,
				isBuyerOrInternalTech(currentUser)
					? getContactsWithInternalTechs(userType).read
					: getContactsForThirdPartySuppliers.read
			),
			fetchMultipleUsers: (emails, targetCollectionName) =>
				dispatch(
					isBuyerOrInternalTech(currentUser)
						? getContactsWithInternalTechs(userType).read({ emails }, targetCollectionName)
						: getContactsForThirdPartySuppliers.read({ emails }, targetCollectionName)
				),

			fetchPMSchedule: bindThunk(
				dispatch,
				plannedMaintenanceSchedulesRestCrudThunks(userType).read
			),
			fetchMultiplePMSchedule: bindThunk(
				dispatch,
				plannedMaintenanceSchedulesRestCrudThunks(userType).readMultiple
			),

			fetchBrands: bindThunk(dispatch, brandsRestCrudThunks(userType).read),
			fetchMultipleBrands: bindThunk(dispatch, brandsRestCrudThunks(userType).readMultiple),

			fetchDepreciationClasses: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? depreciationClassesRestCrudThunksForSupplier.read
					: depreciationClassesRestCrudThunksForBuyer.read
			),
			fetchMultipleDepreciationClasses: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? depreciationClassesRestCrudThunksForSupplier.readMultiple
					: depreciationClassesRestCrudThunksForBuyer.readMultiple
			),
			fetchRegionsWithChildren: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? fetchRegionsWithChildrenForSupplier
					: fetchRegionsWithChildrenForBuyer
			),
			fetchMultipleRegions: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? regionsRestCrudThunksForSupplier.readMultiple
					: regionsRestCrudThunksForBuyer.readMultiple
			),
			fetchLocationTypes: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? locationTypesRestCrudThunksForSupplier.read
					: locationTypesRestCrudThunksForBuyer.read
			),
			fetchMultipleLocationTypes: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? locationTypesRestCrudThunksForSupplier.readMultiple
					: locationTypesRestCrudThunksForBuyer.readMultiple
			),
			fetchPlannedMaintenanceTemplates: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? plannedMaintenanceTemplatesRestCrudThunksForSupplier.readLite
					: plannedMaintenanceTemplatesRestCrudThunksForBuyer.readLite
			),
			fetchMultiplePlannedMaintenanceTemplates: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? plannedMaintenanceTemplatesRestCrudThunksForSupplier.readMultiple
					: plannedMaintenanceTemplatesRestCrudThunksForBuyer.readMultiple
			),
			fetchMeterTypes: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? meterTypesRestCrudThunksForSupplier.read
					: meterTypesRestCrudThunksForBuyer.read
			),
			fetchMultipleMeterTypes: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? meterTypesRestCrudThunksForSupplier.readMultiple
					: meterTypesRestCrudThunksForBuyer.readMultiple
			),
			fetchAreasWithHierarchy: bindThunk(
				dispatch,
				fetchAreasWithHeirarchy(
					userType === ROLE_TYPES.SUPPLIER ? ROLE_TYPES.SUPPLIER : ROLE_TYPES.BUYER
				)
			),
			fetchMultipleAreas: bindThunk(dispatch, areasRestCrudThunks(userType).readMultiple),
			fetchAreas: bindThunk(dispatch, areasRestCrudThunks(userType).read),
			fetchVendors: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? vendorsRestCrudThunksForSupplier.readLite
					: vendorsRestCrudThunksForBuyer.readLite
			),
			fetchMultipleVendors: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? vendorsRestCrudThunksForSupplier.readMultiple
					: vendorsRestCrudThunksForBuyer.readMultiple
			),
			fetchLabels: (
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			) =>
				dispatch(
					labelsOnPartsRestCrudThunksForSupplier.read(
						{ ...params, no_pagination: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
					)
				),
			fetchMultipleLabels: bindThunk(dispatch, labelsOnPartsRestCrudThunksForSupplier.read),
			fetchAssetLabels: (params, targetCollectionName) =>
				dispatch(
					labelsOnAssetsRestCrudThunks(userType).read(
						{ no_pagination: true },
						targetCollectionName,
						null,
						{ sort_by: 'associatedAssetsCount', order: 'desc' }
					)
				),
			fetchContractorClients: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? contractorClientsRestCrudThunksForSupplier.read
					: contractorClientsRestCrudThunksForBuyer.read
			),
			fetchMultipleContractorClients: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? contractorClientsRestCrudThunksForSupplier.readMultiple
					: contractorClientsRestCrudThunksForBuyer.readMultiple
			),
			fetchContractorLocations: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? contractorLocationsRestCrudThunksForSupplier.read
					: contractorLocationsRestCrudThunksForBuyer.read
			),
			fetchMultipleContractorLocations: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? contractorLocationsRestCrudThunksForSupplier.readMultiple
					: contractorLocationsRestCrudThunksForBuyer.readMultiple
			),
			fetchContractors: (params, targetCollectionName) =>
				dispatch(
					ContractorPrivateNetworksRestCrudThunksForSupplier.read(params, targetCollectionName)
				),
			fetchFieldTechs: bindThunk(dispatch, fieldTechsRestCrudThunksForSupplier.read),
			fetchMultipleFieldTechs: bindThunk(
				dispatch,
				fieldTechsRestCrudThunksForSupplier.readMultiple
			),
			fetchAssetTypesAdditionalFields: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? assetTypesAdditionalFieldsRestCrudThunksForSupplier.read
					: assetTypesAdditionalFieldsRestCrudThunksForBuyer.read
			),
			fetchMultipleAssetTypesAdditionalFields: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? assetTypesAdditionalFieldsRestCrudThunksForSupplier.readMultiple
					: assetTypesAdditionalFieldsRestCrudThunksForBuyer.readMultiple
			),
			fetchCustomers: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? customersRestCrudThunksForSupplier.read
					: customersRestCrudThunksForBuyer.read
			),
			// Populates the walkthroughs Site Survey filter from the grouped-by-title endpoint so the
			// options are distinct survey titles (the filter matches the walkthrough title, not ids).
			fetchSiteSurveysGrouped: bindThunk(
				dispatch,
				userType === ROLE_TYPES.SUPPLIER
					? siteSurveysGroupedRestCrudThunksForSupplier.read
					: siteSurveysGroupedRestCrudThunksForBuyer.read
			),
		}),
		[dispatch, userType, currentUser]
	);
	return useMemo(
		() =>
			getFilters({
				filterTargetCollectionName,
				overviewCollectionName,
				updateFilters,
				userType,
				currentUser,

				//States
				companyConfig,
				locations,
				areas,
				workOrderPriorities,
				assetTypes,
				problemTypes,
				supplierFacilities,
				assets,
				spendCategories,
				resolutionTypes,
				users,
				workOrderLabels,
				planned_maintenance_schedules,
				brands,
				depreciationClasses,
				regions,
				locationTypes,
				plannedMaintenanceTemplates,
				meterTypes,
				vendors,
				labels,
				assetLabels,
				contractorClients,
				contractorLocations,
				contractorPrivateNetworks,
				fieldTechs,
				assetTypesAdditionalFields,
				customers,
				siteSurveysGrouped,
				//Bound Actions
				...boundActions,
			}),
		[
			filterTargetCollectionName,
			overviewCollectionName,
			updateFilters,
			userType,
			currentUser,
			companyConfig,
			locations,
			areas,
			workOrderPriorities,
			assetTypes,
			problemTypes,
			supplierFacilities,
			assets,
			spendCategories,
			resolutionTypes,
			users,
			workOrderLabels,
			planned_maintenance_schedules,
			brands,
			depreciationClasses,
			regions,
			locationTypes,
			plannedMaintenanceTemplates,
			meterTypes,
			vendors,
			labels,
			assetLabels,
			contractorClients,
			contractorLocations,
			contractorPrivateNetworks,
			fieldTechs,
			assetTypesAdditionalFields,
			customers,
			siteSurveysGrouped,
			boundActions,
		]
	);
};
